import { Component, effect, input, OnInit, signal } from '@angular/core';
import { TextWidthPipe } from '../../pipes/text-width.pipe';

@Component({
  selector: 'rid-klank-switch-klank',
  imports: [TextWidthPipe],
  templateUrl: './rid-klank-switch-klank.html',
  styleUrl: './rid-klank-switch-klank.css',
})
export class RidKlankSwitchKlank implements OnInit {
  klank = input.required<string>();

  // the currently shown klank with a unique id to track animations
  protected shown = signal<{ k: string; id: string } | undefined>(undefined);

  constructor() {
    // when the input changes, play the swap animation
    effect(() => {
      const klank = this.klank();

      this.swap(klank);
    });
  }

  ngOnInit(): void {
    this.shown.set({ k: this.klank(), id: `${Math.random()}` });
  }

  // swap the shown klank with an animation
  private swap(klank: string) {
    this.shown.set({ k: klank, id: `${Math.random()}` });
  }
}
